import { NgModule } from '@angular/core';
import { TagIdsToTagsPipe } from './tag-ids-to-tags.pipe';


@NgModule({
    imports: [],
    exports: [TagIdsToTagsPipe],
    declarations: [TagIdsToTagsPipe],
    providers: [],
})
export class TagIdsToTagsPipeModule { }
